import { Navigate, useLocation } from 'react-router-dom';

interface LegacyRedirectProps {
  readonly to: string;
}

export function LegacyRedirect({ to }: LegacyRedirectProps) {
  const { search, hash } = useLocation();

  return <Navigate replace to={`${to}${search}${hash}`} />;
}
